module.exports = __webpack_public_path__ + "img/3dglasses.92c0f23e.svg";